import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=490f0010&scoped=true&"
import script from "./ReservationList.vue?vue&type=script&lang=js&"
export * from "./ReservationList.vue?vue&type=script&lang=js&"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=490f0010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f0010",
  null
  
)

export default component.exports